import React,{useState,useEffect,useRef} from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import {isEmpty} from 'lodash'
import { useNavigate } from "react-router-dom";
import {useToast} from '../../common/component/Toast'
import CommonInput from '../../common/component/commonInput';
import useValidation from '../../common/utils/validationRules';
import CommonButton from '../../common/component/commonButton';
import CommonPasswordInput from '../../common/component/commonPassword';
import CommonLoader from '../../common/component/commonLoader';
import logoImg from '../../assests/images/logo-img.png'
import eye from '../../assests/images/Eye.png';
import CommonCheckbox from '../../common/component/commonCheckBox';
import { createLogin } from '../../service/action/actioncreator/LoginAction/LoginAction';
import { useLoader } from '../../common/component/LoaderProvider';
import {decryptUsingAES256, encryptUsingAES256} from '../../common/utils/index'
import { useTranslation } from 'react-i18next';
import fetchTranslations,{ getTranslate } from '../../service/action/actioncreator/CommonAction/Common';
import TranslationInitializer from '../../common/translation/i18n';
import { getValue } from '@testing-library/user-event/dist/utils';
import FooterComponent from '../pages/FooterComponent';

const Login = () => {
  const [resErrorFlag,setResErrorFlag] =useState(false)
  const { t, i18n } = useTranslation('translation');
  const { showToast } = useToast();
  const { showLoader, hideLoader } = useLoader();
  const dispatch = useDispatch();
  const { validateField } = useValidation();
  const buttonRef = useRef(null);
  const translation = useSelector((state) => state.commonReducer.translateResponse);

  const { register, control, handleSubmit, formState: { errors },getValues,watch,setValue,clearErrors } = useForm(
    {
      defaultValues: {
        accountMemo: false, 
    },
    }
  );
  const navigate = useNavigate();
  const loading=useSelector(state=>state.loginReducer.loginLoading)

  watch('Email')
  watch('Password')
  watch('accountMemo')

  // useEffect(()=>{
  // if(errorFlag){
  //   setValue('Email','')
  //   setValue('Password','')
  //  clearErrors(['Email','Password'])
  // }
  // },[errorFlag,errors])

  const onSubmit = (data) => {
    const trimmedEmail = getValues('Email').trim();
    var payload={
      email:trimmedEmail,
      password:encryptUsingAES256(getValues('Password')?.trim()),
    }
    var headers={
      AccessIdentifier:'validate' 
    }
    if(!isEmpty(trimmedEmail) && !isEmpty(getValues('Password'))){
        dispatch(createLogin(payload,headers,navigate,setResErrorFlag,showLoader,hideLoader))
    }
  };
  const handleRemoveData=()=>{
    setValue('Password','')
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      buttonRef.current.click();
    }
  };


  // Add event listener to the input
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  return (
    <div className="main-container">
  <div className="login-container">
  <div className="login-box text-center">
    <div className="display-flex"> 
    <img src={logoImg} alt="log-img" className='logo-img'/>
    </div>
       <div className="login-form" style={{
        position:'relative'
       }}>
       <div className="mb-3">
           <CommonInput
              name="Email"
              placeholder={t('placeholder_email')}  
              register={register}
              errors={errors}
              validationFn={validateField}
              requiredField={false}
              inputStyle={true}
              errorStyle={false}
              resErrorFlag={resErrorFlag}
            
            />
            </div>
            <div className="mt-2">
            <CommonPasswordInput
              name="Password"
               placeholder={t('placeholder_password')}           
              register={register}
              errors={errors}
              validationFn={validateField}
              control={control}
              disabled={false} 
              inputStyle={true}
              errorStyle={false}
              resErrorFlag={resErrorFlag}
              handleRemoveData={handleRemoveData}
            /> 
            </div>
            <div className="mt-4 forgot-password text-sm">
            <Link to="/forgotpassword">{t("text_forgot_password_link")}</Link>
            </div>
            <div className="mt-4 checkbox">
          <CommonCheckbox
                name="accountMemo"
                label={t("text_rememeber_me")}
                register={register}
                setValue={setValue}
                getValues={getValues}
                errors={errors}
            />
            </div>
            <CommonButton 
            label={t("text_button_log_in")} 
            inputStyle={true}  
            buttonRef={buttonRef}
            disabled={isEmpty(getValues('Email')) || isEmpty(getValues('Password'))}
            onClick={handleSubmit(onSubmit)} className={resErrorFlag ? "btn mt-3 btn-width btn-padding input-style-common text-white err-btn-color" : "btn mt-3 btn-width btn-padding input-style-common text-white"} type="submit" variant={!resErrorFlag ? "success" : "danger"} />
            <div className="mt-5">
            <hr />
            {errors.Email && <div className="p-error">{errors.Email.message}</div>}
            {errors.Password && <div className="p-error">{errors.Password.message}</div>}
            {resErrorFlag && isEmpty(errors) &&
              <div className="p-error">{t("text_incorrect_login_password")} </div>
            }
            {isEmpty(errors) && !resErrorFlag && <> 
              <div className="fw-bold mt-2 custom-text-break font-size-fs-6">
                {t("text_require_credentials_error_message")}
                </div>
            </>
             }
            </div>
            <div className=""style={{
              position:'absolute',
              width:'80%',
              top:'99.5%',
              

            }}>
              <FooterComponent/>
            </div>
            </div>
        <CommonLoader loading={loading} />
      </div>
    </div>
    </div>
  );
};
export default Login;

